export function formatReportName (report) {
  const name = report ? report.realName || report.userName : ''
  return String(name || '').trim() || '用户'
}

export function formatReportDate (value) {
  const text = String(value || '')
  return /^\d{8}/.test(text) ? `${text.slice(4, 6)}月${text.slice(6, 8)}日` : '日期未知'
}

export function formatSleepEfficiency (value) {
  if (value === null || value === undefined || String(value).trim() === '') return '--'
  const number = Number(value)
  if (!Number.isFinite(number)) return '--'
  return `${Number.parseFloat(number.toFixed(2))}%`
}

export function sleepEfficiencyStatus (value) {
  if (value === null || value === undefined || String(value).trim() === '') return 'unknown'
  const number = Number(value)
  if (!Number.isFinite(number)) return 'unknown'
  if (number >= 85) return 'good'
  if (number >= 65) return 'fair'
  return 'poor'
}
